import { Model } from '../core/base.model';

import { SimpleEntityActions } from '@app/classes';

export class Announcement extends Model {
    static permission = new SimpleEntityActions('companyNotificationAnnouncement');

    protected static _type = 'announcements';

    protected static _resource = 'companyManagement/companies/:company/notifications/announcements';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['subject', 'message', 'employeeFilterId', 'isTest'];

    // Subject
    get subject(): string {
        return this._attributes['subject'];
    }

    set subject(val: string) {
        this._attributes['subject'] = val;
    }

    // Message
    get message(): string {
        return this._attributes['message'];
    }

    set message(val: string) {
        this._attributes['message'] = val;
    }

    get employeeFilterId(): number {
        return this._attributes['employeeFilterId'];
    }

    set employeeFilterId(val: number) {
        this._attributes['employeeFilterId'] = val;
    }

    // Used for sending test announcement during store
    set isTest(val: boolean) {
        this._attributes['isTest'] = val;
    }
}
